import Api from "./baseApi";

export default {
  // Tüm varyantları getir
  getAll: () => Api.get("/api/variants"),
  
  // Belirli bir GroupKey'e ait varyantları getir
  getByGroupKey: (groupKey) => Api.get(`/api/variants/group/${groupKey}`),
  
  // ProductId'ye göre varyant getir
  get: (productId) => Api.get(`/api/variants/${productId}`),
  
  // Tüm benzersiz GroupKey'leri getir
  getGroupKeys: () => Api.get("/api/variants/groups"),
  
  // Yeni varyant ekle
  post: (variant) => Api.post("/api/variants", variant),
  
  // Varyant güncelle
  put: (variant) => Api.put(`/api/variants/${variant.productId}`, variant),
  
  // Ana varyantı değiştir
  switchMajor: (productId) => Api.post(`/api/variants/switch-major/${productId}`),
  
  // Varyant sil
  delete: (productId) => Api.delete(`/api/variants/${productId}`),
  
  // Varyant grubunu sil
  deleteGroup: (groupKey) => Api.delete(`/api/variants/group/${encodeURIComponent(groupKey)}`)
};

